<ng-container *ngIf="sourceLanguage$ | async"></ng-container>

<div class="translate-update">
  <h6>Update Source Translations</h6>

  <div class="translate-update-field-container">
    <label class="translate-update-field-container-title">Operation</label>
    <p-select ngDefaultControl [options]="[{value:'add',label:'Add Key'},{value:'update',label:'UpdateKey'}]" [(ngModel)]="selectedOperation" optionLabel="label"
    optionValue="value" placeholder="Action" />
  </div>

  <div
    *ngIf="selectedOperation === 'update'"
    class="translate-update-field-container"
  >
    <div class="translate-update-field-content">
        <label>Select Key</label>
        <p-select ngDefaultControl [options]="keys" [(ngModel)]="selectedKey" placeholder="Translation Key"  (onChange)="updateSelectedKeyValue()"/>

      <div *ngIf="selectedKey">
        <div class="form-field">
          <label>Source Text</label>
          <br>
            <input pInputText [(ngModel)]="selectedKeyValue" />
        </div>
      </div>

      <div class="translate-update-action-btn-container">
        <button
          pButton
          [disabled]="
            isUpdating ||
            !selectedKey ||
            selectedKeyValue === translation[selectedKey]
          "
          severity="primary"
          (click)="updateKey()"
        >
          <ng-container *ngIf="isUpdating">

            <span style="padding-right: 8px"
              ><app-loading-dots size="3px"></app-loading-dots
            ></span>
          </ng-container>
          Update
        </button>
      </div>
    </div>
  </div>
  <div
    *ngIf="selectedOperation === 'add'"
    class="translate-update-field-container"
  >
    <div class="form-field">
      <label>New Key</label>
      <br>
      <input
        placeholder="New Key"
        [(ngModel)]="newKey"
        fluid
        pInputText
      />
    </div>
    <div class="form-field">
      <label>Source Text</label>
      <br>
      <input
        placeholder="Text Content"
        [(ngModel)]="newContent"
        fluid
        pInputText
      />
    </div>
    <div class="translate-update-action-btn-container">
      <button
        (click)="addKey()"
        pButton
        [disabled]="
          isUpdating ||
          !newKey ||
          !newContent ||
          translation?.hasOwnProperty(newKey)
        "
        status="primary"
      >
        <ng-container *ngIf="isUpdating">
          <span style="padding-right: 8px"
            ><app-loading-dots size="3px"></app-loading-dots
          ></span>
        </ng-container>
        Add
      </button>
    </div>
  </div>
</div>
